import styled from 'styled-components';

export const Container = styled.div`
  .map-container {
    width: 100%;
    height: 100vh;
  }
`;
